const initialState = {
  fetchingState: "none", // loading , success, error
  items: [],
  error: null,
  nbResult: 0,
  id: null
};

export const fetchingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_FETCHING": {
      return initialState;
    }
    case `SET_FETCHING_ID`: {
      return { ...state, id: action.id };
    }
    case `SET_FETCHING_ITEMS`: {
      return { ...state, items: [...action.items] };
    }
    case `FETCH_ITEMS_PENDING`: {
      return { ...state, fetchingState: "fetching" };
    }
    case `FETCH_ITEMS_FULFILLED`: {
      let { data, nbResult } = action.payload.data;
      if (state.id === "FETCHING_ALBUMS") {
        data = data.map(d => {
          d.medias = d.medias.map(i => ({ ...i, inAlbum: true }));
          return d;
        });
      }

      return {
        ...state,
        fetchingState: "success",
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_ITEMS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetchingState: "error",
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/fetching.js